import { queryOptions } from "@tanstack/react-query";
import { apiGET } from "~/app/api/apiCallsService";
import { occUrl } from "~/app/api/occ/occFetch";

/** Session-derived search facet availability shared by search consumers. */
export interface SearchContext {
  validSearchSuffixes: string;
}

export async function fetchSearchContext(): Promise<SearchContext> {
  const response = await apiGET(occUrl("/search/context"), {
    headers: { Accept: "application/json", "Content-Type": "application/json" },
  });
  if (!response.ok) {
    throw new Error(`Failed to load search context: ${response.status}`);
  }
  return response.json() as Promise<SearchContext>;
}

export const searchContextQueryOptions = () =>
  queryOptions({
    queryKey: ["search-context"],
    queryFn: fetchSearchContext,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
